import { useEffect } from "react"
import { supabase } from "@/lib/supabase"
import { useAuthStore } from "@/store/auth.store"
import { mapUserData } from "@/types/domain.types"

export function useInitializeApp() {
  const { setUser, setLoading } = useAuthStore()

  useEffect(() => {
    // Verificar sessão atual
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        setUser(mapUserData(session.user))
      } else {
        setUser(null)
      }
    })

    // Escutar mudanças de autenticação
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((_event, session) => {
      if (session?.user) {
        setUser(mapUserData(session.user))
      } else {
        setUser(null)
      }
    })

    return () => subscription.unsubscribe()
  }, [setUser, setLoading])
} 